<template>
  <div class="ca-management-page">
    <el-card class="page-card" shadow="never">
      <div slot="header" class="card-header">
        <h2 class="page-title">CA 授权管理</h2>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openAddDialog">新增</el-button>
      </div>
      <el-form :inline="true" :model="searchForm" class="search-form" @submit.native.prevent>
        <el-form-item label="姓名">
          <el-input v-model.trim="searchForm.name" placeholder="请输入被授权人姓名" clearable
            @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model.trim="searchForm.mobile" placeholder="请输入被授权人手机号" clearable
            @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model.trim="searchForm.idNo" placeholder="请输入被授权人身份证号" clearable
            @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleResetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" v-loading="tableLoading" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="authRole" label="授权角色" min-width="120" />
        <el-table-column prop="mobile" label="手机号" min-width="120" />
        <el-table-column prop="name" label="姓名" min-width="120" />
        <el-table-column prop="idCard" label="身份证号" min-width="180" />
        <el-table-column prop="message" label="授权结果" min-width="180" />
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.authStatus)" size="small">
              {{ statusLabel(scope.row.authStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status !== 2" type="text" size="small"
              @click="handleFreeze(scope.row)">冻结</el-button>
            <el-button v-if="scope.row.status === 2" type="text" size="small" style="color: #67C23A;"
              @click="handleRestore(scope.row)">恢复</el-button>
            <el-button type="text" size="small" style="color: #F56C6C;" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination background layout="total, sizes, prev, pager, next" :total="total" :page-size="pageSize"
          :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" @current-change="handlePageChange"
          @size-change="handleSizeChange" />
      </div>
    </el-card>
    <!-- 新增弹窗 -->
    <el-dialog :title="dialogStep === 1 ? '选择授权角色' : '新增授权'" :visible.sync="dialogVisible" width="500px"
      :close-on-click-modal="false" @close="resetForm">
      <!-- 第一步：选择角色 -->
      <div v-if="dialogStep === 1" class="role-select-wrap">
        <el-button :loading="authLoading && selectedAuthRole === 21" class="role-btn" @click="handleSelectRole(21)">
          <i class="el-icon-user-solid"></i>
          <span>超级管理员</span>
        </el-button>
        <el-button :loading="authLoading && selectedAuthRole === 4" class="role-btn" @click="handleSelectRole(4)">
          <i class="el-icon-office-building"></i>
          <span>企业管理员</span>
        </el-button>
      </div>
      <!-- 第二步：填写信息 -->
      <template v-else>
        <div class="selected-role-tag">
          <el-tag size="medium">{{ selectedAuthRole === 21 ? '超级管理员' : '企业管理员' }}</el-tag>
          <el-button type="text"   icon="el-icon-back" @click="dialogStep = 1">重新选择</el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="addForm" label-width="150px">
          <el-form-item label="被授权人姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入被授权人姓名" clearable maxlength="20" />
          </el-form-item>
          <el-form-item label="被授权人手机号" prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入被授权人手机号" clearable maxlength="11" />
          </el-form-item>
          <el-form-item label="被授权人身份证" prop="idCard">
            <el-input v-model="form.idCard" placeholder="请输入被授权人身份证号" clearable maxlength="18" />
          </el-form-item>
          <el-form-item v-if="needAuthCode" label="授权码" prop="smsCode">
            <el-input v-model="form.smsCode" placeholder="请输入授权码" clearable maxlength="6" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { bindPersonSeal, getPersonAuth, getPersonSealList, getNeedAuth,editPersonStatus } from '@/api/modules/ca'
export default {
  name: 'CaManagement',
  data() {
    return {
      tableLoading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      dialogStep: 1,
      selectedAuthRole: null,
      authLoading: false,
      submitLoading: false,
      smsSending: false,
      smsCountdown: 0,
      smsTimer: null,
      needAuthCode: false,
      searchForm: {
        idNo: '',
        name: '',
        mobile: '',
        credential: '',
        authRole: ''
      },

      form: {
        name: '',
        mobile: '',
        idCard: '',
        smsCode: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入被授权人姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入被授权人手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入被授权人身份证号', trigger: 'blur' },
          { pattern: /^\d{17}[\dXx]$/, message: '身份证号格式不正确', trigger: 'blur' }
        ],
        smsCode: [
          {
            validator: (rule, value, callback) => {
              if (!this.needAuthCode) {
                callback()
                return
              }
              if (!value) {
                callback(new Error('请输入授权码'))
                return
              }
              if (String(value).length !== 6) {
                callback(new Error('授权码为6位'))
                return
              }
              callback()
            }, trigger: 'blur'
          }
        ],
      }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    async loadList() {
      this.tableLoading = true
      try {
        const listRes = await getPersonSealList({
          idNo: this.searchForm.idNo,
          name: this.searchForm.name,
          mobile: this.searchForm.mobile,
          credential: this.searchForm.credential,
          authRole: this.searchForm.authRole,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        const data = listRes.data || {}
        const records = data.records || data.list || []
        this.tableData = records.map(item => ({
          ...item,
          idCard: item.idCard || item.idNo || '',
          status: item.status ?? item.authStatus ?? item.bindStatus
        }))
        this.total = Number(data.total || 0)
      } catch (e) {
        this.tableData = []
        this.total = 0
        this.$message.error('获取列表失败')
      } finally {
        this.tableLoading = false
      }
    },

    handleSearch() {
      this.currentPage = 1
      this.loadList()
    },

    handleResetSearch() {
      this.searchForm = {
        idNo: '',
        name: '',
        mobile: '',
        credential: '',
        authRole: ''
      }
      this.currentPage = 1
      this.loadList()
    },

    handlePageChange(page) {
      this.currentPage = page
      this.loadList()
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadList()
    },

    openAddDialog() {
      this.dialogStep = 1
      this.selectedAuthRole = null
      this.needAuthCode = false
      this.dialogVisible = true
    },

    async handleSelectRole(type) {
      this.selectedAuthRole = type
      this.authLoading = true
      try {
        const needAuthRes = await getNeedAuth(type)
        this.needAuthCode = !!needAuthRes.data
        // 同时调用 getPersonAuth
        await getPersonAuth(type)
        this.dialogStep = 2
      } catch (e) {
        this.$message.error('获取授权配置失败')
      } finally {
        this.authLoading = false
      }
    },

    resetForm() {
      this.$refs.addForm && this.$refs.addForm.resetFields()
      this.form = { name: '', mobile: '', idCard: '', smsCode: '' }
      this.dialogStep = 1
      this.selectedAuthRole = null
      this.needAuthCode = false
      this.smsCountdown = 0
      clearInterval(this.smsTimer)
    },

    async sendSmsCode() {
      if (!this.form.idCard) {
        this.$message.warning('请先输入被授权人身份证号')
        return
      }
      const idCardReg = /^\d{17}[\dXx]$/
      if (!idCardReg.test(this.form.idCard)) {
        this.$message.warning('身份证号格式不正确')
        return
      }
      this.smsSending = true
      try {
        // TODO: 替换为实际发送短信接口
        // await sendCaAuthSms({ idCard: this.form.idCard })
        this.$message.success('验证码已发送')
        this.smsCountdown = 60
        this.smsTimer = setInterval(() => {
          this.smsCountdown--
          if (this.smsCountdown <= 0) {
            clearInterval(this.smsTimer)
          }
        }, 1000)
      } catch (e) {
        this.$message.error('发送验证码失败：' + (e.message || '未知错误'))
      } finally {
        this.smsSending = false
      }
    },

    handleSubmit() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          const res = await bindPersonSeal({
            name: this.form.name,
            mobile: this.form.mobile,
            authRole: this.selectedAuthRole,
            credential: this.form.smsCode,
            idNo: this.form.idCard
          })
          if (res.code === 200) {
            this.$message.success('新增授权成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error(res.msg || '新增授权失败')
          }
        } catch (e) {
          this.$message.error('新增授权失败：' + (e.message || '未知错误'))
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleFreeze(row) {
      this.$confirm(`确定冻结 ${row.name} 的授权吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          this.$message.success('冻结成功')
          this.loadList()
        } catch (e) {
          this.$message.error('冻结失败')
        }
      }).catch(() => { })
    },

    handleRestore(row) {
      this.$confirm(`确定恢复 ${row.name} 的授权吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(async () => {
        try {
          this.$message.success('恢复成功')
          this.loadList()
        } catch (e) {
          this.$message.error('恢复失败')
        }
      }).catch(() => { })
    },

    handleDelete(row) {
      this.$confirm(`确定删除 ${row.name} 的授权吗？删除后不可恢复。`, '警告', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          this.$message.success('删除成功')
          this.loadList()
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => { })
    },

    statusLabel(status) {
      const map = { ACTIVE: '正常', LOCKED: '冻结', DELETE: '删除' }
      return map[status] ?? '未知'
    },
    statusTagType(status) {
      const map = { ACTIVE: 'success', LOCKED: 'warning', DELETE: 'danger' }
      return map[status] ?? ''
    }
  },
  beforeDestroy() {
    clearInterval(this.smsTimer)
  }
}
</script>

<style scoped>
/* ===== 角色选择步骤样式 ===== */
.role-select-wrap {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: 32px 0;
}

.role-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 120px;
  border-radius: 12px;
  border: 2px solid #dcdfe6;
  background: #fafbfc;
  cursor: pointer;
  transition: all 0.3s ease;
}


.role-btn i {
  font-size: 32px;
  color: #409eff;
  margin-bottom: 8px;
}

.role-btn span {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.selected-role-tag {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

/* ===== 页面整体布局 ===== */
.ca-management-page {
  padding: 24px;
  background: #f5f7fa;
  min-height: calc(100vh - 84px);
}

/* ===== 卡片样式 ===== */
.page-card {
  min-height: 480px;
  border-radius: 12px;
  border: none;
  background: #ffffff;
  transition: box-shadow 0.3s ease;
}

.page-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.search-form {
  margin-bottom: 16px;
}

/* ===== 卡片头部优化 ===== */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: -0.5px;
  position: relative;
  padding-left: 16px;
}

.page-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 22px;
  border-radius: 2px;
}

/* 新增按钮样式 */
.card-header .el-button {
  border-radius: 8px;
  padding: 9px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.25);
}

.card-header .el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
}

/* ===== 表格深度优化 ===== */
:deep(.el-table) {
  border-radius: 8px;
  overflow: hidden;
  margin-top: 8px;
}

:deep(.el-table__header-wrapper) {
  background: #fafbfc;
}

:deep(.el-table__header) th {
  background: linear-gradient(180deg, #fafbfc 0%, #f0f2f5 100%);
  color: #606266;
  font-weight: 600;
  font-size: 13px;
  height: 48px;
  border-bottom: 1px solid #ebeef5;
}

:deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

:deep(.el-table__row:hover) {
  background-color: #f5f7fa !important;
}

:deep(.el-table__row td) {
  height: 56px;
  font-size: 13px;
  color: #606266;
  border-bottom: 1px solid #f0f2f5;
}

:deep(.el-table__row:last-child td) {
  border-bottom: none;
}

/* 序号列样式 */
:deep(.el-table .cell) {
  line-height: 1.5;
}

/* 姓名列加粗 */
:deep(.el-table__row td:nth-child(2) .cell) {
  font-weight: 500;
  color: #303133;
}

/* 身份证列等宽字体 */
:deep(.el-table__row td:nth-child(3) .cell) {
  font-family: 'SF Mono', Monaco, monospace;
  letter-spacing: 0.5px;
  color: #606266;
}

/* ===== 状态标签样式 ===== */
:deep(.el-tag) {
  border-radius: 12px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  border: none;
}

:deep(.el-tag--success) {
  background: rgba(103, 194, 58, 0.1);
  color: #67c23a;
}

:deep(.el-tag--danger) {
  background: rgba(245, 108, 108, 0.1);
  color: #f56c6c;
}

:deep(.el-tag--info) {
  background: rgba(144, 147, 153, 0.1);
  color: #909399;
}

/* ===== 操作按钮样式 ===== */
:deep(.el-button--text) {
  font-size: 13px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

:deep(.el-button--text:hover) {
  background: rgba(64, 158, 255, 0.1);
}

:deep(.el-button--text[style*="color: #67C23A"]:hover) {
  background: rgba(103, 194, 58, 0.1);
}

:deep(.el-button--text[style*="color: #F56C6C"]:hover) {
  background: rgba(245, 108, 108, 0.1);
}

/* 按钮分隔符 */
:deep(.el-button--text + .el-button--text) {
  position: relative;
  margin-left: 8px;
  padding-left: 12px;
}

:deep(.el-button--text + .el-button--text::before) {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 14px;
  background: #e4e7ed;
}

/* ===== 空状态样式 ===== */
:deep(.el-table__empty-block) {
  min-height: 280px;
}

:deep(.el-table__empty-text) {
  color: #909399;
  font-size: 14px;
  line-height: 2;
}

/* ===== 分页样式优化 ===== */
.pagination-wrap {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f2f5;
  display: flex;
  justify-content: flex-end;
}

:deep(.el-pagination.is-background .el-pager li) {
  border-radius: 6px;
  background: #f5f7fa;
  font-weight: 500;
  transition: all 0.2s ease;
}

:deep(.el-pagination.is-background .el-pager li:hover) {
  background: #ecf5ff;
  color: #409eff;
}

:deep(.el-pagination.is-background .el-pager li.active) {
  background: #409eff;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.35);
}

:deep(.el-pagination.is-background .btn-prev),
:deep(.el-pagination.is-background .btn-next) {
  border-radius: 6px;
  background: #f5f7fa;
}

/* ===== 弹窗样式优化 ===== */
:deep(.el-dialog) {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.15);
}

:deep(.el-dialog__header) {

  padding: 20px 24px;
  margin: 0;
}

:deep(.el-dialog__title) {
  color: black;
  font-size: 16px;
  font-weight: 600;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  color: black;
  font-size: 18px;
  transition: all 0.2s ease;
}

:deep(.el-dialog__headerbtn .el-dialog__close:hover) {
  color: black;
}

:deep(.el-dialog__body) {
  padding: 32px 28px;
}

:deep(.el-dialog__footer) {
  padding: 16px 24px 24px;
  border-top: 1px solid #f0f2f5;
}

/* 表单样式优化 */
:deep(.el-form-item__label) {
  font-weight: 500;
  color: #606266;
  font-size: 13px;
}

:deep(.el-input__inner) {
  border-radius: 8px;
  height: 40px;
  border-color: #dcdfe6;
  transition: all 0.2s ease;
}

:deep(.el-input__inner:focus) {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
}

:deep(.el-input__inner:hover) {
  border-color: black;
}

/* 验证码按钮样式 */
.sms-btn {
  border-radius: 6px !important;
  font-weight: 500;
  transition: all 0.2s ease;
}

.sms-btn:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.25);
}

/* 弹窗底部按钮 */
:deep(.el-dialog__footer .el-button) {
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 500;
  transition: all 0.2s ease;
}

:deep(.el-dialog__footer .el-button--primary) {
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.25);
}

:deep(.el-dialog__footer .el-button--primary:hover) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
}

/* ===== 加载状态 ===== */
:deep(.el-loading-mask) {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
}

:deep(.el-loading-spinner .el-loading-text) {
  color: #409eff;
  font-weight: 500;
}

/* ===== 响应式优化 ===== */
@media (max-width: 768px) {
  .ca-management-page {
    padding: 12px;
  }

  .page-title {
    font-size: 18px;
  }

  .card-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  :deep(.el-table__header) th,
  :deep(.el-table__row) td {
    padding: 12px 8px;
  }
}
</style>
